import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IDebugVisualizerService = ( createDecorator('debugVisualizerService'));
export { IDebugVisualizerService };
